import { render, staticRenderFns } from "./Recruiters.vue?vue&type=template&id=141a48e6&scoped=true"
import script from "./Recruiters.vue?vue&type=script&lang=js"
export * from "./Recruiters.vue?vue&type=script&lang=js"
import style0 from "./Recruiters.vue?vue&type=style&index=0&id=141a48e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a48e6",
  null
  
)

export default component.exports